import { SHARES_TOKEN_REFRESH_SUCCESS } from './shares.reducer';

export const PRESENTATION_FETCH = 'PRESENTATION/FETCH';
export const PRESENTATION_FETCH_SUCCESS = 'PRESENTATION/FETCH_SUCCESS';
export const PRESENTATION_FETCH_FAILURE = 'PRESENTATION/FETCH_FAILURE';
export const PRESENTATION_SHARED_FETCH = 'PRESENTATION/SHARED/FETCH';
export const PRESENTATION_SHARED_FETCH_SUCCESS =
  'PRESENTATION/SHARED/FETCH_SUCCESS';
export const PRESENTATION_SAVE = 'PRESENTATION/SAVE';
export const PRESENTATION_SAVE_SUCCESS = 'PRESENTATION/SAVE_SUCCESS';
export const PRESENTATION_SAVE_FAILURE = 'PRESENTATION/SAVE_FAILURE';
export const PRESENTATION_EDIT = 'PRESENTATION/EDIT';
export const PRESENTATION_ADD_EXTENSIONS = 'PRESENTATION/ADD_EXTENSIONS';
export const PRESENTATION_ADD_EXTENSIONS_SUCCESS =
  'PRESENTATION/ADD_EXTENSIONS_SUCCESS';
export const PRESENTATION_ADD_EXTENSIONS_FAILURE =
  'PRESENTATION/ADD_EXTENSIONS_FAILURE';
export const PRESENTATION_REMOVE_EXTENSION = 'PRESENTATION/REMOVE_EXTENSION';
export const PRESENTATION_REMOVE_EXTENSION_SUCCESS =
  'PRESENTATION/REMOVE_EXTENSION_SUCCESS';
export const PRESENTATION_REMOVE_EXTENSION_FAILURE =
  'PRESENTATION/REMOVE_EXTENSION_FAILURE';
export const PRESENTATION_SHARES_FETCH = 'PRESENTATION/SHARES_FETCH';
export const PRESENTATION_SHARES_FETCH_SUCCESS =
  'PRESENTATION/SHARES_FETCH_SUCCESS';
export const PRESENTATION_SHARES_FETCH_FAILURE =
  'PRESENTATION/SHARES_FETCH_FAILURE';
export const PRESENTATION_REMOVE_SHARE = 'PRESENTATION/REMOVE/SHARE';
export const PRESENTATION_REMOVE_SHARE_SUCCESS =
  'PRESENTATION/REMOVE_SHARE_SUCCESS';
export const PRESENTATION_REMOVE_SHARE_FAILURE =
  'PRESENTATION/REMOVE_SHARE_FAILURE';
export const PRESENTATION_FAVOURITE = 'PRESENTATION/FAVOURITE';
export const PRESENTATION_FAVOURITE_SUCCESS = 'PRESENTATION/FAVOURITE_SUCCESS';
export const PRESENTATION_FAVOURITE_FAILURE = 'PRESENTATION/FAVOURITE_FAILURE';
export const PRESENTATION_OPEN_SELECT_MEDIA_DIALOG =
  'PRESENTATION/OPEN_SELECT_MEDIA_DIALOG';
export const PRESENTATION_CLOSE_SELECT_MEDIA_DIALOG =
  'PRESENTATION/CLOSE_SELECT_MEDIA_DIALOG';
export const PRESENTATION_TREE_CHANGE = 'PRESENTATION/TREE/CHANGE';
export const PRESENTATION_SELECT = 'PRESENTATION/SELECT';
export const PRESENTATION_ADD_NEW = 'PRESENTATION/ADD_NEW';

const initialState = {};

export const fetchPresentation = id => ({
  type: PRESENTATION_FETCH,
  payload: { id },
});

export const favouriteShare = ({ id, token, favourite }) => ({
  type: PRESENTATION_FAVOURITE,
  payload: { id, token, favourite },
});

export const fetchPresentationShares = id => ({
  type: PRESENTATION_SHARES_FETCH,
  payload: { id },
});

export const removeShare = (presentationId, shareId) => ({
  type: PRESENTATION_REMOVE_SHARE,
  payload: { presentationId, shareId },
});

export const fetchSharedPresentation = token => ({
  type: PRESENTATION_SHARED_FETCH,
  payload: { token },
});

export const savePresentation = presentation => ({
  type: PRESENTATION_SAVE,
  payload: { presentation },
});

export const addNewPresentation = history => ({
  type: PRESENTATION_ADD_NEW,
  payload: { history },
});

export const editPresentation = presentation => ({
  type: PRESENTATION_EDIT,
  payload: { presentation },
});

export const removeExtensionFromPresentation = (id, extensionId) => ({
  type: PRESENTATION_REMOVE_EXTENSION,
  payload: { id, extensionId },
});

export const presentationOpenSelectMediaDialog = () => ({
  type: PRESENTATION_OPEN_SELECT_MEDIA_DIALOG,
});

export const presentationCloseSelectMediaDialog = () => ({
  type: PRESENTATION_CLOSE_SELECT_MEDIA_DIALOG,
});

export const presentationTreeChange = (id, children) => ({
  type: PRESENTATION_TREE_CHANGE,
  payload: { id, children },
});

export const selectPresentation = presentation => ({
  type: PRESENTATION_SELECT,
  payload: { presentation },
});

export const presentationReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case PRESENTATION_FETCH_SUCCESS:
    case PRESENTATION_SHARED_FETCH_SUCCESS:
    case PRESENTATION_SAVE_SUCCESS: {
      return { ...state, ...payload };
    }
    case PRESENTATION_OPEN_SELECT_MEDIA_DIALOG:
      return { ...state, openSelectMediaDialog: true };
    case PRESENTATION_CLOSE_SELECT_MEDIA_DIALOG:
      return { ...state, openSelectMediaDialog: false };
    case PRESENTATION_SHARES_FETCH_SUCCESS:
      return {
        ...state,
        shares: [...payload],
      };
    case PRESENTATION_SHARES_FETCH_FAILURE: {
      console.error(PRESENTATION_SHARES_FETCH_FAILURE);
      return state;
    }
    case PRESENTATION_FETCH_FAILURE: {
      console.error(PRESENTATION_FETCH_FAILURE);
      return state;
    }
    case PRESENTATION_REMOVE_SHARE_FAILURE: {
      console.error(PRESENTATION_REMOVE_SHARE_FAILURE);
      return state;
    }
    case PRESENTATION_REMOVE_EXTENSION_SUCCESS: {
      const config = { ...state.config };
      delete config[payload.extensionId];
      return {
        ...state,
        config,
        extensions: state.extensions.filter(
          extension => extension.id !== payload.extensionId
        ),
      };
    }
    case SHARES_TOKEN_REFRESH_SUCCESS: {
      return {
        ...state,
        shareToken: payload.token,
      };
    }
    case PRESENTATION_FAVOURITE_SUCCESS: {
      return {
        ...state,
        favourites: payload.favourites,
      };
    }
    case PRESENTATION_REMOVE_SHARE_SUCCESS: {
      return {
        ...state,
        shares: state.shares.filter(data => data.id !== payload.shareId),
      };
    }
    case PRESENTATION_ADD_EXTENSIONS_SUCCESS: {
      return {
        ...state,
        extensions: [...payload.data],
      };
    }
    case PRESENTATION_SELECT: {
      return {
        ...state,
        ...payload.presentation,
      };
    }
    default:
      return state;
  }
};

export const searchTree = (element, id, parent = null, extensionId = null) => {
  if (
    extensionId &&
    element.extensions &&
    element.extensions.includes(extensionId)
  ) {
    return { element, parent };
  }
  if (element.id === id) {
    return { element, parent };
  } else if (element.children != null) {
    let result = null;
    element.children.forEach(subElement => {
      let tmpResult = searchTree(subElement, id, element, extensionId);
      if (tmpResult) {
        result = tmpResult;
      }
    });
    return result;
  }
  return {};
};



// WEBPACK FOOTER //
// ./src/reducers/presentation.reducer.js